import React, {useContext} from 'react';
import RefreshIcon from '@heroicons/react/outline/RefreshIcon';
import FormContext from '../form-context';

export function FieldControlFrame({enabled, manual, children}) {
    return enabled ? <div data-field-control={manual ? 'manual' : undefined}
        style={manual ? {outline: '2px dashed #e879f9', outlineOffset: '2px', borderRadius: '4px'} : undefined}>{children}</div> : children;
}

export default function FieldControlStatus({name, label, id = name, disabled, readOnly}) {
    const context = useContext(FormContext);
    const field = context.fieldControl?.[name];
    if (!field?.manual && !field?.pendingRevert) return null;

    return <span className="inline-flex items-center gap-2 text-xs font-medium leading-5 whitespace-nowrap shrink-0">
        <span className={field.pendingRevert ? 'text-gray-500' : 'text-fuchsia-700'}>
            {field.pendingRevert ? 'Reverts On Save' : 'Manual'}
        </span>
        {!field.pendingRevert && <>
            <span className="text-gray-500" aria-hidden="true">·</span>
            <button type="button" className="inline-flex items-center gap-1 text-primary-500 hover:underline disabled:text-gray-400 disabled:no-underline"
                disabled={!field.canRevert || disabled || readOnly}
                aria-describedby={!field.canRevert ? `${id}-source-status` : undefined}
                aria-label={`Revert ${label || name}`}
                onClick={() => context.onFieldControlAction?.(name, label || name, context.replaceFieldValues)}>
                <RefreshIcon className="w-3.5 h-3.5" aria-hidden="true"/>
                Revert
            </button>
        </>}
    </span>;
}

export function FieldControlMessage({name, id = name}) {
    const context = useContext(FormContext);
    const field = context.fieldControl?.[name];
    return (field?.manual || field?.pendingRevert) && !field.canRevert && field.unavailableReason
        ? <p id={`${id}-source-status`} className="mt-1 text-xs text-gray-500">{field.unavailableReason}</p>
        : null;
}
